import React, { useEffect, useState, useCallback } from "react";
import { Card, Button } from "react-bootstrap";
import {
  formatDate,
  normalizeString,
} from "../../functions/Utils";
import LoadingMessage from "../LoadingMessage";
import { FaCarSide } from "react-icons/fa6";
import { CarHireSearchParams } from "../../types";

interface Props {
  params: CarHireSearchParams;
}

interface CityProps {
  icon: React.ReactNode;
  city_name: string;
  date: string;
}

const CityCard: React.FC<CityProps> = ({ icon, city_name, date }) => {
  return (
    <div className="d-flex align-items-center p-2 border rounded mb-2">
      {/* Picto à gauche */}
      <div className="me-3">{icon}</div>
      {/* Texte à droite */}
      <div>
        <div className="fw-bold">{city_name}</div>
        <div className="text-muted">{formatDate(date)}</div>
      </div>
    </div>
  );
};

const CarRentalsSearchCard: React.FC<Props> = ({ params }) => {
  const [offers, setOffers] = useState<[]>([]);
  const [nb_offers, setNbOffers] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { pickup_city, dropoff_city, pickup_date, dropoff_date } = params;


  const KayakUrl = `https://www.kayak.fr/cars/${normalizeString(
    pickup_city.cityname
  )}, ${pickup_city.country_code}${
    pickup_city.cityname !== dropoff_city.cityname
      ? `/${normalizeString(dropoff_city.cityname)}, ${
          dropoff_city.country_code
        }`
      : ""
  }/${pickup_date}/${dropoff_date};map`;

  const fetchCarOffers = useCallback(async () => {
    setLoading(true);
    setError(null);
    setOffers([]);
    try {
    } catch (err) {
      setError("Une erreur est survenue lors de la recherche de vols.");
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchCarOffers();
  }, [fetchCarOffers]);

  return (
    <Card className="my-4 border-0 bg-light rounded-4">
      <Card.Body>
        <Card.Title className="text-center"></Card.Title>
        <Card.Text className="m-0 p-0">
          <div className="d-flex justify-content-between align-items-center">
            <div className="row w-100 g-1">
              {/* Deux colonnes côte à côte */}
              <div className="col-md-6">
                <CityCard
                  icon={<FaCarSide size={30} />}
                  city_name={pickup_city.cityname}
                  date={pickup_date}
                />
              </div>
              <div className="col-md-6">
                <CityCard
                  icon={<FaCarSide size={30} />}
                  city_name={dropoff_city.cityname}
                  date={dropoff_date}
                />
              </div>
            </div>
          </div>

          <br />
        </Card.Text>

        {loading && <LoadingMessage />}

        <div className="d-flex justify-content-center">
          <Button
            variant="primary"
            href={KayakUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            See all offers
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CarRentalsSearchCard;
